import React from "react";
import Collapsible from "react-collapsible";
// import { domain, headers, contentUrl } from '../../Variables'
import Loader from 'react-loader-spinner'
import HttpServices from "../../utils/Http.services";
import { checkConditionGroup, checkTranslation, getObject, imageAddress, translate } from "../../utils/useful";
import FixedView from "../FixedView";
import StagesManager from "../StagesManager";
import HelpButton from "../HelpButton";
import FilterEditorInput from "./FilterEditorInput";
// import { lngTranslations } from "../../utils/useful";
// import { transform } from "lodash";
// import SelectWithSearch from "./SelectWithSearch";
// import { imageAddress } from "../../utils/useful";



class FrameSelectInput extends React.Component {

    state = {
        selected: '',
        subCheckCount: [],
        subCheck: [],
        isOpen: false,
        data: [],
        title: '',
        tempData: [],
        options: [],
        mainParents: [],
        mainParentsShow: [],
        isLoading: true,
        choosen: null,
        openRow: {},
        row: {},
        view: false,
        conditionFields: [

            { key: 'applet', type: 'SelectInput', information: { label: "{{lang}}Frame's applet", type: 'local', items: [], placeholder: '{{lang}}select', required: false } },
            { key: 'name', type: 'TextInput', col: '12', information: { label: "{{lang}}Frame's name", placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'mode', type: 'SelectInput', information: { label: "{{lang}}Frame's mode", type: 'local', items: [{ value: 'collection', title: '{{lang}}Collection' }, { value: 'inquiry', title: '{{lang}}Inquiry' },], placeholder: '{{lang}}select', required: false } },
            { key: 'cDate', type: 'DateInput', col: '12', information: { label: "{{lang}}Frame's creation date", placeholder: '{{lang}}insertLabel', required: true } },

        ]

    }

    // toggleOpen = (makeOpen) => {

    //     let final = makeOpen != null ? makeOpen : !this.state.isOpen
    //     if (final != this.state.isOpen) {
    //         if (!this.state.isOpen) {
    //             document.addEventListener('mousedown', this.closeBox);
    //         } else {
    //             document.removeEventListener('mousedown', this.closeBox);
    //         }
    //     }
    //     // if (this.refs.icon)
    //     //     this.refs.icon.classList.toggle("rotate-180")


    //     this.setState({ isOpen: final, data: this.props.data }, () => {
    //         this.changePositionOnOpen()

    //     })

    // }


    componentDidMount() {
        // if(this.props.title){
        //     this.setState({value:this.props.title})
        // }
        this.init()
        // this.setState({ view: true })

        // window.addEventListener('scroll', this.changePositionOnOpen, true);
        // window.addEventListener('resize', this.changePositionOnOpen, true);

        // this.changePositionOnOpen()

        // setTimeout(() => {
        // }, 10);
    }


    componentDidUpdate(prevProp) {
        // if (this.props.data != prevProp.data) {
        //     // console.log(this.props.data, prevProp.data)
        //     // this.init()
        //     this.checkData(this.state.options)

        // }
        // let info = JSON.parse(JSON.stringify(this.props.header?.information))
        // // console.log(info?.multiple, this.state.multiple)
        // if (info?.multiple !== this.state.multiple) {

        //     let info = this.props.header?.information
        //     let choosen = this.state.choosen ? JSON.parse(JSON.stringify(this.state.choosen)) : null

        //     if (info.multiple && !Array.isArray(choosen) && choosen) {
        //         choosen = [choosen]
        //     }

        //     if (!info.multiple && Array.isArray(choosen) && choosen.length > 0) {
        //         choosen = choosen[0]
        //     }

        //     // console.log(choosen)



        //     this.setState({ choosen, multiple: info.multiple }, () => {
        //         if (choosen != this.state.choosen) {
        //             this.props.changeValue(this.props.header.key, choosen, this.props.extra)
        //         }
        //     })
        // }
    }

    init() {

        this.fetch()

        // console.log(this.props.data)

        // if (this.props.header.information) {
        //     if (this.props.header.information.type == "local") {
        //         this.setState({ options: this.props.header.information.items }, () => {
        //             this.countCalculator()
        //         })
        //     } else if (this.props.header.information.type == "api") {
        //         this.fetch()
        //         // this.setState({data:[]})
        //     }
        // }
    }


    fetch() {

        // console.log("FETCH")
        let info = JSON.parse(JSON.stringify(this.props.header?.information))

        this.setState({ isLoading: true, multiple: info.multiple })
        let mainParents = this.state.mainParents
        // let parentBody = this.props.header.information.body ?? {}
        // let body = this.props.header.information.body ?? {}
        // parentBody.filter = this.props.header.information.parentFilter
        let body = this.props.header.information.filter ?? {}
        if (this.props.header.information.select) {
            body.select = this.props.header.information.select
        }

        // console.log(this.props.variables)
        if (this.props.header.information.sort) {
            body.sort = this.props.header.information.sort
        }
        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                let baseValue = value.replace(/{/g, '').replace(/}/g, '')

                if (getObject(this.props.fullData, baseValue)) {
                    body[key] = getObject(this.props.fullData, baseValue)

                } else if (this.props.variables) {
                    body[key] = this.props.variables[baseValue]
                }
                // console.log("VAR")
            }
        }

        // console.log(this.props.header.information.address, body)
        // HttpServices.request(this.props.header.information.parentAddress, parentBody, (mainParents, fetchError) => {
        HttpServices.request(this.props.header.information.address ?? 'getFramesApplet', body, (data, fetchError) => {

            // console.log(data)

            this.setState({ isLoading: false })
            if (fetchError) {
                this.setState({ fetchError })
                return
            }

            let newData = []
            // let choosen
            let applets = []

            // console.log('data.infodata.info', data.info)
            // for (let i = 0; i < mainParents.info.length; i++) {
            //     const standard = mainParents.info[i];

            data.info.forEach(element => {
                // let newTitle
                // let newValue
                // let newParent
                let mainParent
                let isMain = false
                if (this.props.header.information.fields.mainParent) {
                    mainParent = getObject(element, this.props.header.information.fields.mainParent)
                    if (!mainParent && !element[this.props.header.information.fields.parent] || element[this.props.header.information.fields.parent]?.length == 0) {
                        isMain = true
                    }
                    // if (mainParents.length > 0 && mainParents.includes(mainParent)) {

                    //     }
                    // else {
                    //     mainParents.push(mainParent)
                    // }
                }

                let myData = {}


                if (this.props.header.information.fields) {
                    for (const [key, value] of Object.entries(this.props.header.information.fields)) {

                        myData[key] = getObject(element, value)

                    }
                }

                if (!mainParent) {
                    applets.push(myData)
                }

                // if (this.props.header.information.fields.value) {
                //     newValue = getObject(element, this.props.header.information.fields.value)
                // }
                // if (this.props.header.information.fields.parent) {
                //     newParent = getObject(element, this.props.header.information.fields.parent)
                // }
                // if (this.props.header.information.fields?.title) {
                //     newTitle = getObject(element, this.props.header.information.fields?.title)
                // }
                // let newImage = null
                // if (this.props.header.information.fields.image) {
                //     newImage = getObject(element, this.props.header.information.fields.image)
                // }


                // myData.type = getObject(element, 'type')
                myData.mainParent = mainParent
                myData.isMain = isMain
                myData._id = element._id

                // newData.push(this.props.data)
                newData.push(myData)



                // if (this.props.data) {

                //     if (Array.isArray(this.props.data)) {

                //         for (let i = 0; i < this.props.data.length; i++) {
                //             const element = this.props.data[i];
                //             let dataValue = typeof element == 'object' ? getObject(element, this.props.header.information.fields?.value) : element

                //             if (dataValue == myData.value) {
                //                 if (!Array.isArray(choosen)) {
                //                     choosen = []
                //                 }
                //                 choosen.push(myData)
                //             }
                //         }


                //     } else {

                //         if (typeof this.props.data == 'object' && this.props.data?.root) {


                //             this.changeFilterValue(null, this.props.data, null)
                //             choosen = this.props.data

                //         } else {
                //             let dataValue = typeof this.props.data == 'object' ? getObject(this.props.data, this.props.header.information.fields?.value) : this.props.data
                //             if (myData.value == dataValue) {
                //                 choosen = myData
                //                 this.props.changeValue(this.props.header.helperKey, myData.value, this.props.extra)

                //             }
                //         }

                //     }
                // }


                // let type = getObject(element, 'type')

                // newData.push({ value: newValue, title: newTitle, image: newImage, parent: newParent, _id: element._id, mainParent: mainParent, isMain, type })
            });
            // }'
            // console.log(newData)


            // if (Array.isArray(choosen)) {
            //     let finalValue = []
            //     choosen.forEach(element => {
            //         finalValue = element.value
            //     })
            //     this.props.changeValue(this.props.header.helperKey, finalValue, this.props.extra)

            // }

            // console.log("HERE", newData)

            let conditionFields = this.state.conditionFields
            conditionFields[0].information.items = applets




            this.setState({
                options: newData,
                tempData: newData,
                mainParents: mainParents?.info,
                mainParentsShow: mainParents?.info,
                // choosen,
                isLoading: false,
                conditionFields
            }, () => {
                this.checkData(newData)

                this.setDefault()
            })
        })
        // })
    }




    checkData = (newData) => {

        // console.log("checkData",newData)
        let choosen

        newData.forEach(myData => {


            if (this.props.data) {

                if (Array.isArray(this.props.data)) {

                    for (let i = 0; i < this.props.data.length; i++) {
                        const element = this.props.data[i]

                        let dataValue = typeof element == 'object' ? getObject(element, this.props.header.information.fields?.value) : element

                        if (dataValue == myData.value) {
                            if (!Array.isArray(choosen)) {
                                choosen = []
                            }
                            choosen.push(myData)
                        }
                    }


                } else {

                    if (typeof this.props.data == 'object' && this.props.data?.root) {


                        // this.changeFilterValue(null, this.props.data, null)
                        choosen = this.props.data

                    } else {
                        let dataValue = typeof this.props.data == 'object' ? getObject(this.props.data, this.props.header.information.fields?.value) : this.props.data
                        if (myData.value == dataValue) {
                            choosen = myData
                            if (this.props.header.helperKey) {
                                this.props.changeValue(this.props.header.helperKey, myData.value, this.props.extra)
                            }


                        }
                    }

                }
            }

        })


        let info = this.props.header?.information

        if (info.multiple && !Array.isArray(choosen) && choosen) {
            choosen = [choosen]
        }

        if (!info.multiple && Array.isArray(choosen) && choosen.length > 0) {
            choosen = choosen[0]
        }


        // console.log("choosen", choosen)


        this.setState({ choosen }, () => {
            if (typeof this.props.data == 'object' && this.props.data?.root) {
                this.changeFilterValue(null, this.props.data, null)
            } else {

                if (Array.isArray(choosen)) {
                    let finalValue = []
                    choosen.forEach(element => {
                        finalValue.push(element.value)
                    })
                    // console.log("finalValue",this.props.header.helperKey, finalValue)
                    if (this.props.header.helperKey) {
                        this.props.changeValue(this.props.header.helperKey, finalValue, this.props.extra)
                    }

                    this.props.changeValue(this.props.header.key, finalValue, this.props.extra)


                } else {
                    if (choosen) {

                        if (this.props.header.helperKey) {
                            this.props.changeValue(this.props.header.helperKey, choosen.value, this.props.extra)
                        }
                        this.props.changeValue(this.props.header.key, choosen.value, this.props.extra)

                    }
                }

            }
        })

    }




    toggleOpen = (open) => {
        let openState = open != null ? open : !this.state.isOpen
        if (openState) {

            this.fixedView.showView()
            if (this.state.choosen?.root) {
                setTimeout(() => {
                    this.stageManager.changeStage('conditional')
                }, 50);
            }

        } else {

            this.fixedView.hideView()


        }


        // this.refs.icon.classList.toggle("rotate-180")

        this.setState({ isOpen: openState, data: this.props.data })

    }


    closeOptions() {

        document.removeEventListener('mousedown', this.closeBox);
        if (this.refs.icon)
            this.refs.icon.classList.toggle("rotate-180")

        this.setState({ isOpen: false, data: this.props.data })
    }



    changeItem = (prop, dontUpdateFixedView) => {

        console.log("changeItem")

        if (prop.type != 'folder') {
            let isMultiple = this.props.header?.information?.multiple

            // console.log(isMultiple)
            if (isMultiple) {

                let choosen = Array.isArray(this.state.choosen) ? this.state.choosen : []
                let currentIndex

                choosen.forEach((element, i) => {
                    if (element.value == prop.value) {
                        currentIndex = i
                    }
                });
                // let currentIndex = choosen.indexOf(prop.value)
                // console.log(currentIndex)
                let added = false
                if (currentIndex == null) {
                    choosen.push(prop)
                    added = true
                } else {
                    choosen.splice(currentIndex, 1)
                }

                this.setState({ choosen }, () => {
                    if (!dontUpdateFixedView) {
                        this.fixedView.getBounding()
                    }
                })

                let finalValue = []
                choosen.forEach(element => {
                    finalValue.push(element.value)
                });

                console.log("finalValue", finalValue)

                // console.log(finalValue)
                this.props.changeValue(this.props.header.key, finalValue, this.props.extra)
                if (this.props.header.helperKey) {
                    setTimeout(() => {
                        this.props.changeValue(this.props.header.helperKey, finalValue, this.props.extra)
                    }, 20);
                }


            } else {


                this.setState({ choosen: prop, isOpen: false })



                // let parent = prop.parent?._id
                // let parents = [prop.value]
                // let parentValue = prop.mainParent

                // this.getParent(parent, parents, () => {
                this.props.changeValue(this.props.header.key, prop.value, this.props.extra)
                if (this.props.header.helperKey) {
                    setTimeout(() => {
                        this.props.changeValue(this.props.header.helperKey, prop.value, this.props.extra)
                    }, 20);
                }

                // setTimeout(() => {
                //     this.props.changeValue(this.props.header.secondKey, parentValue, this.props.extra)
                // }, 10);
                this.toggleOpen(false)
                // })

            }

        }

        this.setState({ validFrames: null })
        // if (this.state.tempData.length > 0) {
        //     this.setState({ options: this.state.tempData })
        // }


    }



    getParent(parent, parents, cb) {

        if (parent == null) {
            parents = []
            cb()
        } else {
            let found = false

            let tempData = this.state.tempData
            if (tempData.length == 0) {
                tempData = this.state.options
            }
            tempData.forEach(element => {


                if (element._id == parent) {
                    found = true
                    parents.splice(0, 0, element?._id)

                    if (element.parent == null) {
                        cb()
                    } else {
                        this.getParent(element.parent?._id, parents, cb)
                    }
                }

            });

            if (found == false) {
                cb()
            }

        }
    }

    setDefault() {
        if (this.props.data && this.props.data.title) {
            this.setState({ choosen: null })
            this.state.options.forEach(option => {
                let data = this.props.data?._id ?? this.props.data
                if (option.value == data) {
                    this.setState({ choosen: option }, () => {
                        this.countCalculator()
                    })
                    // this.props.changeValue(this.props.header.key, this.props.data.title, option.withOperator, option.flexible)
                    return
                }
            });



        }
    }

    // setWrapperRef(node) {
    //     this.wrapperRef = node;
    // }



    // spliter(source, string) {
    //     var stringArray = string.split('.')
    //     var finalString = source
    //     stringArray.forEach(element => {
    //         finalString = finalString[element]
    //     });
    //     return finalString
    // }


    // conditionalSettings(param, condition) {
    //     if (this.props.settings) {
    //         if (this.props.settings[param] == condition) {
    //             return true
    //         }
    //     }
    //     return false
    // }


    search = async (value) => {

        this.toggleOpen(true)

        let options = this.state.tempData


        if (value == "") {
            await this.setState({ mainParentsShow: this.state.mainParents, options: this.state.tempData, searchOptions: null })
            await this.setState({ tempData: [], isSearching: false })
        } else {
            if (this.state.tempData.length == 0) {
                await this.setState({ tempData: this.state.options })
                options = this.state.options
            }
            var values = []
            // let options = this.state.tempData
            // var values = this.props.data.filter((e) => e.title === value)
            options.forEach(element => {
                if (element?.title.toLowerCase().includes(value.toLowerCase()) || (translate(element, 'title') && translate(element, 'title').toLowerCase().includes(value.toLowerCase()))) {

                    let found = false

                    options.forEach(child => {
                        if (child.parent?._id == element._id) {

                            found = true
                        }
                    });

                    if (found == false) {
                        values.push(element)
                    }
                }
            })
            let mainParents = []
            for (let x = 0; x < this.state.mainParents.length; x++) {
                const parent = this.state.mainParents[x];

                for (let i = 0; i < values.length; i++) {
                    const child = values[i];
                    if (child.mainParent == parent._id) {
                        if (!mainParents.includes(parent)) {
                            mainParents.push(parent)
                        }
                    }

                }
            }
            this.setState({ mainParentsShow: mainParents, options: values, isSearching: true })
            this.setState({ searchOptions: values })

            // }
        }
    }





    componentWillUnmount() {

        // this.window.removeEventListener('scroll', this.changePositionOnOpen, true);
        // this.window.removeEventListener('resize', this.changePositionOnOpen, true);

        if (this.unlisten)
            this.unlisten();
    }



    // setWrapperRef(node) {
    //     this.wrapperRef = node;
    // }



    changePositionOnOpen = () => {
        if (this.currentNode) {
            let bounds = this.currentNode.getBoundingClientRect()


            // if (this.refs.box) {
            //     let boxBounds = this.refs.box.getBoundingClientRect()



            this.setState({ width: bounds.width }, () => { })
            // }
        }
    }



    showSub(prop) {

        this.state.subCheck[prop._id] = !this.state.subCheck[prop._id] ?? true;
        this.setState({ subCheck: this.state.subCheck })
    }



    countCalculator() {

        // if (this.state.tempData.length > 0)
        //     this.setState({ options: this.state.tempData })


        for (let i in this.state.options) {
            let id = this.state.options[i]._id
            if ((typeof (this.state.subCheckCount[this.state.options[i]._id]) == 'number')) {
                break;
            }
            for (let j in this.state.options) {
                if (this.state.options[j].parent?._id == id) {
                    this.state.subCheckCount[id] = 1;
                    this.setState({ subCheckCount: this.state.subCheckCount });
                    break;

                }
            }
        }
    }

    liActive(id) {
        let l = [];
        l[id] = true;


        this.setState({ brandCheck: l });
    }

    selectedMnu(id) {

        // this.state.selected = [];
        // this.state.selected[id] = 1;
        this.setState({ selected: id })
    }

    openParent = () => {

    }
    modelNotListed = () => {
        this.props.modelNotListed()
    }
    setRow = (mainParent) => {
        let row = this.state.row
        if (!row[mainParent._id]) {
            row[mainParent._id] = true
        } else {

            row[mainParent._id] = false
        }
        this.setState({ row })
    }
    onHide = () => {
        this.setState({ isOpen: false })
    }


    selectApplet = (applet) => {
        this.setState({ currentApplet: applet }, () => {
            this.stageManager.changeStage('frames')
            setTimeout(() => {
                this.fixedView.getBounding()
                if (this.viewContainer) {
                    this.viewContainer.scrollTo(0, 0)
                }
            }, 50);
        })
    }


    loadMainParents = () => {
        // console.log('loadMainParents')
        return this.state.options.map((prop, index) => {
            if (!prop.mainParent) {
                return (
                    <button onClick={() => this.selectApplet(prop)} className="mb-2 w-100" key={index} style={{ paddingLeft: 0, marginTop: 0, marginBottom: 0, paddingTop: '0px' }}>
                        <div className="select-item-addlisting" key={index} style={{ backgroundColor: (this.state.selected == prop._id) ? '#FFF3DB' : 'transparent', alignItems: 'center', borderBottomColor: '#f2f4f6', borderBottomStyle: 'solid', borderBottomWidth: 0, borderTop: '0px solid #f2f4f6', borderRight: 0, paddingTop: '0px' }}>
                            <div className="d-flex" style={{ alignItems: 'center', justifyContent: 'space-between', paddingRight: 0 }}>
                                <div className="flexcb w-100" style={{ padding: '5px 5px 5px 10px', display: 'flex', gap: '5px', cursor: 'pointer', width: '90%', }}>
                                    {/* onClick={() => { this.setRow(prop) }} */}
                                    <div className="flexc">
                                        <img className="mrd-2" src={imageAddress(prop.image, 'applet', 'thumb')} width='25px' />
                                        <div>
                                            <p className="d-flex flex-column text-semibold" style={{ margin: 0, color: this.state.subCheckCount[prop._id] ? '#202020' : '#101010', fontSize: 14, fontWeight: this.state.subCheckCount[prop._id], textAlign: 'start' }}>
                                                {checkTranslation(prop.title)}
                                            </p>
                                            {/* <p className="text-smallest">Applet</p> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <Collapsible open={!this.state.row[prop._id]} transitionTime={100} >

                            {this.loadRow(prop._id, 20)}

                        </Collapsible > */}
                    </button>
                )
            }
        })

    }


    iconSelector(type) {
        switch (type) {
            case 'collection':
                return '/assets/icons/applets/database.png'

            case 'messenger':
                return '/assets/icons/portals/chat (2).png'

            case 'drive':
                return '/assets/icons/applets/drive.png'

            case 'folder':
                return '/assets/icons/folder (1).png'

            case 'page':
                return '/assets/icons/applets/notebook.png'



            default:
                return '/assets/icons/useful/pages.png'
        }
    }

    loadRow(parent, paddingLeft) {
        return this.state.options.map((prop, index) => {
            let letShow = false
            let selected = false

            let mparent = prop.parent ? prop.parent[prop.parent.length - 1] : null
            let mainParent = prop.mainParent

            // console.log('mparent', mparent)
            // console.log('mainParent', mainParent)
            if ((this.state.searchOptions != null)) {
                letShow = true
            }

            if (mparent == '' || mparent == null) {
                let parents = this.state.options.filter((a) => { return ((String(a._id) == String(mparent))) })
                if (parents.length == 0) {
                    letShow = false
                }
            }
            if ((mparent == parent || (mainParent == parent && prop.isMain))) {
                letShow = true
            }

            if (Array.isArray(this.state.choosen)) {
                selected = this.state.choosen.filter((a) => a.value == prop.value).length > 0
            } else {
                if (prop.value == this.state.choosen?.value) {
                    selected = true
                }
            }

            // let children = this.state.options.filter((a) => { return ((String(a.parent) == String(prop._id))) })
            // if (children.length > 0) {
            //     hasChildren = true
            // }

            if (letShow) {
                return (
                    <div className="d-flex w-100" key={index} style={{ marginTop: 1, marginBottom: 1 }}>

                        <div className="d-flex flex-column w-100" style={{ paddingLeft: paddingLeft, marginTop: 0, marginBottom: 0, paddingTop: '0px', }}>
                            <div style={{ borderLeft: '1px solid #eee', paddingTop: 0, }}>
                                <div className="select-item-addlisting" key={index} style={{ alignItems: 'center', borderBottomColor: '#f2f4f6', borderBottomStyle: 'solid', borderBottomWidth: 0, borderTop: paddingLeft == 0 ? '1px solid #f2f4f6' : 'none', borderRight: 0, }}>
                                    <div className="d-flex" style={{ alignItems: 'center', justifyContent: 'space-between', paddingRight: (paddingLeft / 2) }}>

                                        <div style={{ height: '1px', backgroundColor: '#eee', width: '12px' }}>
                                        </div>

                                        <button className="flexc w-100 hover-gray-no-filter w-100 py-2 px-2 br-4" onClick={() => { this.changeItem(prop) }} style={{ backgroundColor: selected ? '#007aff20' : 'transparent', padding: '0px 0px 0px 0px', display: 'flex', gap: '5px', cursor: 'pointer', width: '90%', }}>

                                            {/* {prop.type == 'folder' && ( */}
                                            <div className='flexcc '>
                                                <img className="transition-all " src={prop.icon ?? this.iconSelector(prop.type)} height={16} alt="" />
                                            </div>
                                            {/* )} */}

                                            <p className="d-flex flex-column text-semibold mld-1 font-size-14" style={{ color: this.state.subCheckCount[prop._id] ? '#202020' : '#101010', fontWeight: this.state.subCheckCount[prop._id], textAlign: 'start' }}>
                                                {checkTranslation(prop.title)}

                                            </p>

                                        </button>
                                    </div>
                                </div>
                                {(this.state.searchOptions == null) ? this.loadRow(prop._id, 12) : ''}

                                {/* {(hasChildren) && (
                                    <div className="flexc" style={{ paddingTop: 10, transform: 'translatey(2px)' }}>
                                        <div style={{ height: '1px', backgroundColor: '#eee', width: '5px' }}>

                                        </div>
                                        <div style={{ height: '5px', backgroundColor: '#eee', width: '1px' }}>

                                        </div>
                                    </div>
                                )} */}
                            </div>

                        </div>
                    </div>

                )
            }

        })


    }

    changeTab = (tab) => {
        this.stageManager.changeStage(tab)
        setTimeout(() => {
            if (this.fixedView) {
                this.fixedView.getBounding()
            }
        }, 50);

    }

    changeFilterValue = (key, value, extra) => {

        // console.log("changeFilterValue")

        let validFrames = []
        let options = this.state.options ?? []

        // console.log("options", options)
        if (value?.root) {
            options.forEach(option => {
                if (option.mainParent && option.type != 'folder') {

                    let variables = option
                    let result = checkConditionGroup(value.root, variables, true, true)

                    // console.log(option,result)

                    if (result) {
                        validFrames.push(option)
                    }
                }
            });
        }

        this.setState({ validFrames, choosen: value }, () => {
            if (this.fixedView && this.fixedView.state.isOpen) {
                this.fixedView.getBounding()
            }
        })

        // console.log("validFrames", validFrames)

        this.props.changeValue(this.props.header.key, value, this.props.extra)
        if (this.props.header.helperKey) {
            setTimeout(() => {
                this.props.changeValue(this.props.header.helperKey, validFrames, this.props.extra)
            }, 20)
        }

    }


    render() {

        let info = this.props.header?.information
        return (
            <div className='w-100' style={{ position: 'relative' }} >
                {/* {this.countCalculator()} */}
                <div className="d-flex" ref={el => this.currentNode = el} onClick={() => this.toggleOpen(true)} style={{ cursor: 'pointer', alignItems: 'center', color: '#fff !important', paddingLeft: 10, flex: 1, width: '100%', borderRadius: 10, borderStyle: 'none', fontSize: 13, padding: '0px' }}>
                    {/* {this.props.icon && (
                        <img className="ml-1 mr-1" src={this.props.icon} style={{ height: 25, objectFit: 'contain' }} />
                    )}
                    <input disabled={this.conditionalSettings('disabled', true)} value={this.state.value} placeholder={this.props.placeholder} onInput={event => { this.search(event.target.value); this.setState({ value: event.target.value }) }} className='mediumiransansfont ' defaultValue={this.state.title} style={{ color: '#323232', padding: 5, flex: 1, width: '100%', borderStyle: 'none', fontSize: 15, background: 'transparent' }} /> */}
                    {(Array.isArray(this.state.choosen) && this.state.choosen.length > 0) ? (
                        <div className="h-100 flexc flex-wrap" style={{}}>
                            {this.state.choosen.map((choose, j) => {
                                return (

                                    <div key={choose.value} className="" style={{ display: 'inline-flex', alignItems: 'center', }}>
                                        <div className="flexcc" style={{ padding: 5, backgroundColor: '#eee', borderRadius: 20, marginRight: 2, marginLeft: 2, flexWrap: 'nowrap', paddingLeft: 7, paddingRight: 7 }}>

                                            <button onClick={(e) => { e.stopPropagation(); this.changeItem(choose, true) }} className="br-20 p-1 flexcc mrd-1" style={{ backgroundColor: '#ffffffcc', width: 16, height: 16 }}>
                                                <img className="opacity-5" src="/assets/icons/close.svg" style={{ paddingLeft: 0, color: '#78b2d0', width: 12, height: 12, }} />
                                            </button>


                                            <p style={{ whiteSpace: 'nowrap', marginBottom: 0, marginRight: 2, marginLeft: 2, fontSize: 12, marginTop: 0, color: '#202020' }}>{checkTranslation(choose?.title)}</p>


                                        </div>

                                    </div>
                                )
                            })}
                        </div>
                    ) : (
                        <div className="h-100 flexc" style={{}}>
                            {this.state.choosen?.root ? (
                                <label className={' mrd-1 mld-1 ' + (this.state.choosen ? '' : "placeholder")}>{translate("Conditional value")}</label>

                            ) : (
                                <label className={' mrd-1 mld-1 ' + (this.state.choosen ? '' : "placeholder")}>{this.state.choosen?.title ? checkTranslation(this.state.choosen?.title) : checkTranslation(this.props.header?.information?.placeholder)}</label>

                            )}
                        </div>
                    )}



                </div>
                {/* {this.state.view && ( */}
                <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={this.onHide} topOffset={5} bottomOffset={30} zIndex={80} xOffset={-5} rightAlign={false} width={300}>

                    <div className="w-100" >
                        <div ref={el => this.viewContainer = el} className={'w-100 m-0'} style={{ borderColor: '#eee', maxHeight: 300, overflow: 'auto', backgroundColor: "#fff", borderRadius: 8, boxShadow: '0px 0px 30px rgba(0,0,0,0.2)', padding: '0px' }}>

                            <StagesManager ref={el => this.stageManager = el} fast={true}  >

                                <div className="w-100" stage={0} stageName={"applets"} >
                                    {info.multiple && (

                                        <div className="w-100 white-bg pt-2 pb-2 px-3" style={{ position: 'sticky', top: 0, zIndex: 1, borderBottom: '1px solid #eee' }}>

                                            <div>
                                                <button className="mrd-3" >
                                                    <p className="font-size-14 text-semibold pb-1" style={{ borderBottom: '2px solid #007aff' }}>{translate("Specific")}</p>
                                                </button>
                                                {/* <HelpButton data={"test"} /> */}

                                                <button onClick={() => this.changeTab('conditional')}>
                                                    <p className="font-size-14 text-semibold pb-1" style={{ borderBottom: '2px solid transparent' }}>{translate("Conditional")}</p>
                                                </button>
                                            </div>


                                        </div>

                                    )}

                                    <div className="w-100 pt-2">

                                        <div className="px-3 mb-">
                                            <p className="text-bold mb-1 font-size-15 ">{translate("Select applet")}</p>
                                        </div>

                                        {this.state.isOpen == true && (
                                            this.loadMainParents()
                                        )}
                                    </div>

                                </div>

                                <div className="w-100" stage={1} stageName={"frames"}>
                                    <div className={'w-100 pb-3'} style={{ display: 'flex', flexDirection: 'column', position: 'relative' }}>
                                        {/* {this.state.mainParentsShow.map((standardParent, i) => {
                                    return ( */}

                                        {/* <div style={{ paddingLeft: 0, marginTop: 0, marginBottom: 0, paddingTop: '0px' }}>
                                    <div className="select-item-addlisting" key={i} style={{ backgroundColor: 'transparent', alignItems: 'center', borderBottomColor: '#f2f4f6', borderBottomStyle: 'solid', borderBottomWidth: 0, borderRight: 0, paddingBottom: '10px' }}>
                                        <div className="d-flex" style={{ alignItems: 'center', justifyContent: 'space-between', }}>
                                            <div className="flexcb w-100" onClick={() => { this.setRow(standardParent) }} style={{ padding: '5px 10px 5px 20px', display: 'flex', gap: '5px', cursor: 'pointer', width: '90%', }}>
                                                <p className="d-flex flex-column" style={{ margin: 0, color: '#101010', fontSize: 14, fontWeight: 'normal', textAlign: 'start' }}>
                                                    {standardParent.title}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.openRow[standardParent._id] && (
                                        <>
                                        </>
                                        )}
                                    </div> */}
                                        <div className="px-1 mb-2 pt-2 white-bg " style={{ position: 'sticky', top: 0, zIndex: 1, borderBottom: '1px solid #eee' }}>
                                            <div className="flexcb w-100  " style={{}}>

                                                <div className="w-100  pb-2  flexc" >
                                                    <button className="flexcc mrd-1" onClick={() => this.changeTab('applets')}>
                                                        <img className=" rotate-180" src={'/assets/icons/useful/angle-right.svg'} height='26px' alt="" />
                                                    </button>
                                                    <div className="flexcc">
                                                        <img className="mrd-2" src={imageAddress(this.state.currentApplet?.image, 'applet', 'thumb')} width='25px' alt="" />
                                                    </div>
                                                    <div>
                                                        <p className="d-flex flex-column text-bold" style={{ margin: 0, color: this.state.subCheckCount[this.state.currentApplet?._id] ? '#202020' : '#101010', fontSize: 14, fontWeight: this.state.subCheckCount[this.state.currentApplet?._id], textAlign: 'start' }}>
                                                            {checkTranslation(this.state.currentApplet?.title)}
                                                        </p>
                                                        <p className="text-smaller">{translate("Select frame")}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* {this.state.isOpen == true && ( */}
                                        {this.loadRow(this.state.currentApplet?._id, 10)}
                                        {/* )} */}

                                        {/* )

                                })} */}
                                    </div>
                                    {
                                        this.state.options.length == 0 && !this.state.isLoading && (
                                            <div className="col-12">
                                                <p style={{ margin: 0, color: '#323232', opacity: 1, fontSize: 14, textAlign: 'center', backgroundColor: '#fff' }}>Found Nothing</p>
                                            </div>
                                        )
                                    }
                                    {
                                        this.state.isLoading && (
                                            <div className="flexcc py-3" style={{}}>
                                                <Loader
                                                    type="Oval"
                                                    color="rgb(255, 197, 0)"
                                                    height="40"
                                                    width="40"
                                                />
                                            </div>
                                        )
                                    }
                                </div>




                                <div className="w-100" stage={1} stageName={"conditional"} >
                                    <div className="w-100 white-bg pt-2 pb-2 px-3" style={{ position: 'sticky', top: 0, zIndex: 1, borderBottom: '1px solid #eee' }}>

                                        <div>
                                            <button className="mrd-3" onClick={() => this.stageManager.changeStage('applets')}>
                                                <p className="font-size-14 text-semibold pb-1" style={{ borderBottom: '2px solid transparent' }}>{translate("Specific")}</p>
                                            </button>
                                            {/* <HelpButton data={"test"} /> */}

                                            <button >
                                                <p className="font-size-14 text-semibold pb-1" style={{ borderBottom: '2px solid #007aff' }}>{translate("Conditional")}</p>
                                            </button>
                                        </div>

                                    </div>

                                    <div className="w-100 pt-2 pb-4">

                                        <div className="px-3 ">
                                            <p className=" mb-1 font-size-13 ">{translate("You can select all frames which are valid for the following conditions")}</p>
                                            {/* <p className="text-bold mb-1 font-size-15 ">{translate("Conditions")}</p> */}


                                            <FilterEditorInput data={this.state.choosen?.root ? this.state.choosen : null} params={this.state.conditionFields} changeValue={this.changeFilterValue} />


                                            {Array.isArray(this.state.validFrames) && this.state.validFrames.length > 0 && (
                                                <div className="mt-2 pb-2">
                                                    <p className="text-semibold font-size-15 mb-1">{translate("Current valid frames")}</p>

                                                    {this.state.validFrames && this.state.validFrames.map((frame, k) => {
                                                        return (
                                                            <div className="flexc w-100  w-100 py-2  " style={{ display: 'flex', }}>

                                                                <div className='flexcc mrd-2'>
                                                                    <img className="transition-all " src={frame.icon ?? this.iconSelector(frame.type)} height={16} alt="" />
                                                                </div>

                                                                <p className="d-flex flex-column text-semibold mld-1 font-size-14 " style={{ color: this.state.subCheckCount[frame._id] ? '#202020' : '#101010', fontWeight: this.state.subCheckCount[frame._id], textAlign: 'start' }}>
                                                                    {checkTranslation(frame.title)}

                                                                </p>

                                                            </div>
                                                        )
                                                    })}

                                                </div>
                                            )}
                                        </div>





                                    </div>

                                </div>



                            </StagesManager>
                        </div>
                    </div>
                </FixedView>

                {/* )} */}
            </div >
        );
    }
}


export default FrameSelectInput;
